export default __webpack_public_path__ + "542abb1ec9ce6cf94a7f649ca1a2d4da.svg";